import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalanceEmailTemplate.DeleteAttachment.IRequest;
type Response = Api.Core.StatementBalanceEmailTemplate.DeleteAttachment.IResponse;
type Headers = Api.Core.StatementBalanceEmailTemplate.DeleteAttachment.IHeaders;
const apiStatementBalanceEmailTemplateDeleteAttachmentPath =
  '/api/Management/StatementBalanceEmailTemplate/:id/DeleteAttachment/:fileId';
export default async function statementBalanceEmailTemplateDeleteAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementBalanceEmailTemplateDeleteAttachmentPath, { id, fileId: request.fileId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
